import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function Experience() {
    return (
        <>
            <Container className='container-margin'>
                <Row className="justify-content-md-center">
                    <Col xs lg="6">
                        <h3 className="mb-5 text-center"><span className="textColor fs-2 border-bottom border-info">Where I’ve Worked</span></h3>
                        <Tabs
                            defaultActiveKey="asyncen"
                            id="uncontrolled-tab-example"
                            className="mb-2"
                        >
                            <Tab eventKey="asyncen" title="Asyncen">
                                <h4 style={{ color: '#ccd6f6' }}>Co-Founder & React Native Developer <a href='https://www.asyncen.com/' target='_blank' className='asyncen'>@Asyncen</a></h4>
                                <p style={{ color: '#a8b2d1' }}>March 2022 - Present</p> <br />
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Write modern, performant, maintainable code for a diverse array of client and internal projects.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"> </i>
                                    <span style={{ color: '#8892b0' }}>
                                        Communicate with multi-disciplinary teams of engineers, designers, producers, and clients on an as-needed basis.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Work closely with developers and management team to develop, document, and manage clients products to ensure quality.
                                    </span>
                                </p>
                            </Tab>
                            <Tab eventKey="kyloApp" title="Kylo Apps">
                                <h4 style={{ color: '#ccd6f6' }}>React js Developer Intern  <a href='https://kyloapps.com/' target='_blank' className='asyncen'>@Kylo Apps </a></h4>
                                <p style={{ color: '#a8b2d1' }}>October 2021 - December 2021</p> <br />
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Worked with a team of four developers to build a charity website for repeated company
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"> </i>
                                    <span style={{ color: '#8892b0' }}>
                                        Developed and maintained code for client websites primarily using  React js,JavaScript, JHTML, CSS, Sass.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Responsible for the integration with api and initially deployed on firebase & cooperate with backend developers.

                                    </span>
                                </p>

                            </Tab>
                            <Tab eventKey="mychariti" title="My Chariti">
                                <h4 style={{ color: '#ccd6f6' }}>Software Engineer Intern <a href='https://www.linkedin.com/company/mychariti/' target='_blank' className='asyncen'>@MyChariti Org </a></h4>
                                <p style={{ color: '#a8b2d1' }}>July 2021 - September 2021</p> <br />
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Collaborated with a small team of designers & developers and used React.js, Next.js and Ant design as tech stack.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"> </i>
                                    <span style={{ color: '#8892b0' }}>
                                        Responsible for the development of website and initially deployed on vercel.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        Payment gateway research and integration with Stripe.
                                    </span>
                                </p>

                            </Tab>
                            <Tab eventKey="ibos" title="iBOS">
                                <h4 style={{ color: '#ccd6f6' }}>Campus Ambassador <a href='https://ibos.io/' target='_blank' className='asyncen'>@iBOS </a> </h4>
                                <p style={{ color: '#a8b2d1' }}>July 2021 - January 2022</p> <br />
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        I was able to learn the importance of time-management, the joy of teamwork and to take ownership of the responsibilities which I had to fulfill so that deadlines do not get missed.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"> </i>
                                    <span style={{ color: '#8892b0' }}>
                                        As a result of networking with other professionals, I was able to further my personal development.
                                    </span>
                                </p>
                                <p>
                                    <i className="fas fa-caret-right arrowIcon"></i>
                                    <span style={{ color: '#8892b0' }}>
                                        One of the best things anyone can have is leadership and communication skills.
                                    </span>
                                </p>

                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Container>


        </>
    )
}

export default Experience